module.exports = __webpack_public_path__ + "img/BOSNewThree.e8ed6859.jpg";